import {REPORT_LISTING_MODAL_QUERY_OPERATION_NAME} from '../queries/reportListingModalQuery';
import {SUBMIT_FEEDBACK_OPERATION_NAME} from '.././mutations/submitFeedbackMutation';

export const BEX_API_OPERATIONS = [
    REPORT_LISTING_MODAL_QUERY_OPERATION_NAME,
    SUBMIT_FEEDBACK_OPERATION_NAME
];
